// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer-footerBox-CunTJ {
    background: var(--footer-bg);
    padding-top: 90px;
}

.Footer-footerContent-zLlD1 {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: var(--common-tertiary-white-foreground);
    text-align: start;
    text-decoration: none;
    margin: 0;
}

.Footer-footerListHeading-KNhX9 {
    font-size: 18px;
    line-height: 28px;
    font-weight: 700;
    margin-bottom: 12px;
    color: var(--common-primary-white-foreground);
    text-align: start;
}

.Footer-copyRightContainer-pT8Xx {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    padding: 42px 0;
    margin-top: 42px;
    color: var(--common-tertiary-white-foreground);
    text-align: center;
    border-top: 1px solid var(--secondary-border);
}

.Footer-footerListContainer-mUZaR {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.Footer-socialListContainerGap-X5k73 {
    gap: 18px;
    grid-gap: 18px;
}

.Footer-paymentListContainerGap-OtXh1 {
    gap: 10px;
    grid-gap: 10px;
}

.Footer-footerListContainer-mUZaR li a {
    display: inline-block;
}

.Footer-paymentCardIcon-eD0o6 {
    width: 32px;
    height: 22px;
    -o-object-fit: contain;
       object-fit: contain;
}

.Footer-usefulLinkListContainer-ZykXg {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 6px;
    grid-gap: 6px;
}

.Footer-usefulLinkListContainer-ZykXg li {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.Footer-usefulLink-qhLOQ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
        -ms-flex-align: baseline;
            align-items: baseline;
    gap: 6px;
    grid-gap: 6px;
}

.Footer-usefulLink-qhLOQ:hover,
.Footer-usefulLink-qhLOQ:focus {
    color: var(--common-primary-white-foreground);
    text-decoration: none;
}

.Footer-usefulLink-qhLOQ svg {
    position: relative;
    top: 2px;
    width: 14px;
    height: 14px;
}

.Footer-isFooterBottomSpace-_YXU6 {
    padding-bottom: 90px;
}

@media (max-width: 1199px) {
    .Footer-footerRowList-J5AO9 {
        row-gap: 24px;
    }
}

@media (max-width: 991px) and (max-width: 768px) {
    .Footer-footerContainer-Cc66z {
        padding-top: 40px;
    }

    .Footer-footerBox-CunTJ {
        padding-top: 60px;
    }
}

@media (max-width: 767px) {
    .Footer-footerContainer-Cc66z {
        padding-top: 24px;
    }

    .Footer-footerListHeading-KNhX9 {
        font-size: 16px;
        line-height: 26px;
        margin-bottom: 6px;
    }

    .Footer-copyRightContainer-pT8Xx {
        padding: 24px 0;
        margin-top: 24px;
    }

    .Footer-footerBox-CunTJ {
        padding-top: 48px;
    }

    .Footer-isFooterBottomSpace-_YXU6 {
        padding-bottom: 78px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,8CAA8C;IAC9C,iBAAiB;IACjB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,2BAAqB;QAArB,wBAAqB;YAArB,qBAAqB;IACrB,QAAQ;IACR,aAAa;AACjB;;AAEA;;IAEI,6CAA6C;IAC7C,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".footerBox {\n    background: var(--footer-bg);\n    padding-top: 90px;\n}\n\n.footerContent {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    color: var(--common-tertiary-white-foreground);\n    text-align: start;\n    text-decoration: none;\n    margin: 0;\n}\n\n.footerListHeading {\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 700;\n    margin-bottom: 12px;\n    color: var(--common-primary-white-foreground);\n    text-align: start;\n}\n\n.copyRightContainer {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    padding: 42px 0;\n    margin-top: 42px;\n    color: var(--common-tertiary-white-foreground);\n    text-align: center;\n    border-top: 1px solid var(--secondary-border);\n}\n\n.footerListContainer {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n}\n\n.socialListContainerGap {\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.paymentListContainerGap {\n    gap: 10px;\n    grid-gap: 10px;\n}\n\n.footerListContainer li a {\n    display: inline-block;\n}\n\n.paymentCardIcon {\n    width: 32px;\n    height: 22px;\n    object-fit: contain;\n}\n\n.usefulLinkListContainer {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    grid-gap: 6px;\n}\n\n.usefulLinkListContainer li {\n    display: flex;\n    align-items: center;\n}\n\n.usefulLink {\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n    grid-gap: 6px;\n}\n\n.usefulLink:hover,\n.usefulLink:focus {\n    color: var(--common-primary-white-foreground);\n    text-decoration: none;\n}\n\n.usefulLink svg {\n    position: relative;\n    top: 2px;\n    width: 14px;\n    height: 14px;\n}\n\n.isFooterBottomSpace {\n    padding-bottom: 90px;\n}\n\n@media (max-width: 1199px) {\n    .footerRowList {\n        row-gap: 24px;\n    }\n}\n\n@media (max-width: 991px) and (max-width: 768px) {\n    .footerContainer {\n        padding-top: 40px;\n    }\n\n    .footerBox {\n        padding-top: 60px;\n    }\n}\n\n@media (max-width: 767px) {\n    .footerContainer {\n        padding-top: 24px;\n    }\n\n    .footerListHeading {\n        font-size: 16px;\n        line-height: 26px;\n        margin-bottom: 6px;\n    }\n\n    .copyRightContainer {\n        padding: 24px 0;\n        margin-top: 24px;\n    }\n\n    .footerBox {\n        padding-top: 48px;\n    }\n\n    .isFooterBottomSpace {\n        padding-bottom: 78px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerBox": `Footer-footerBox-CunTJ`,
	"footerContent": `Footer-footerContent-zLlD1`,
	"footerListHeading": `Footer-footerListHeading-KNhX9`,
	"copyRightContainer": `Footer-copyRightContainer-pT8Xx`,
	"footerListContainer": `Footer-footerListContainer-mUZaR`,
	"socialListContainerGap": `Footer-socialListContainerGap-X5k73`,
	"paymentListContainerGap": `Footer-paymentListContainerGap-OtXh1`,
	"paymentCardIcon": `Footer-paymentCardIcon-eD0o6`,
	"usefulLinkListContainer": `Footer-usefulLinkListContainer-ZykXg`,
	"usefulLink": `Footer-usefulLink-qhLOQ`,
	"isFooterBottomSpace": `Footer-isFooterBottomSpace-_YXU6`,
	"footerRowList": `Footer-footerRowList-J5AO9`,
	"footerContainer": `Footer-footerContainer-Cc66z`
};
module.exports = ___CSS_LOADER_EXPORT___;
